import script from "./NotificationTeaser.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationTeaser.vue?vue&type=script&setup=true&lang=js"

import "./NotificationTeaser.vue?vue&type=style&index=0&id=3563ea87&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3563ea87"]])

export default __exports__